import React from 'react';
import useI18n from '../../hooks/useI18n';

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  const { t } = useI18n();

  return (
    <div className="flex flex-col items-center justify-center h-64 lg:h-72 px-20">
      <p className="text-gray-500 text-center">{t('bulkUpload.uploading')}</p>
      <div className="w-full bg-gray-200 rounded-full h-2.5 mt-4">
        <div
          className="bg-blue-600 h-2.5 rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
